const API_BASE = process.env.REACT_APP_API_BASE || 'https://y2lw0r0cc1.execute-api.ap-southeast-2.amazonaws.com/dev';

export const API_ENDPOINT = `${API_BASE}/chat`;
export const PROFILE_ENDPOINT = `${API_BASE}/profile`;
export const SESSIONS_ENDPOINT = `${API_BASE}/sessions`;
export const DAILY_USAGE_ENDPOINT = `${API_BASE}/usage/daily`;
export const STREAKS_ENDPOINT = `${API_BASE}/usage/streaks`;
export const SESSION_END_ENDPOINT = (sessionId) => `${API_BASE}/sessions/${sessionId}/end`;
export const FEEDBACK_ENDPOINT = `${API_BASE}/feedback`;
export const MOODS_ENDPOINT = `${API_BASE}/analysis/moods`;
export const MOOD_CATEGORIES_ENDPOINT = `${API_BASE}/analysis/mood-categories`;
export const ATTACHMENT_STYLE_ENDPOINT = `${API_BASE}/analysis/attachment-style`;
export const TOPIC_CATEGORIES_ENDPOINT = `${API_BASE}/analysis/topic-categories`;
export const TRIGGERS_ENDPOINT = `${API_BASE}/analysis/triggers`;
export const ROOTS_ENDPOINT = `${API_BASE}/analysis/roots`;
export const CONVERT_TO_AI_ENDPOINT = (sessionId) => `${API_BASE}/sessions/${sessionId}/convert-to-ai`;